import type { QueryClient } from "@tanstack/react-query";
import type { Transaction } from "../shared/types";

export function invalidateTransactionRelated(client: QueryClient): void {
  for (const key of ["transactions", "transaction-overview", "subscription"]) {
    void client.invalidateQueries({ queryKey: ["member", key] });
  }
}

/** The mutation response refreshes detail; related queries re-read totals and limits. */
export function cacheTransactionResult(client: QueryClient, transaction: Transaction): void {
  client.setQueryData(["member", "transaction", transaction.id], transaction);
  invalidateTransactionRelated(client);
}
